// KYC daily limit (customer side only): what the admin / staff screen shows about a customer's tries today and when the
// Reset button is offered. Pure functions (no React) so they are easy to test.
export const triesLabel = (info) => {
    if (!info) return "-";
    return `${info.used} of ${info.limit} used${info.blocked ? " - limit reached" : ""}`;
};

// The Reset button: only with the permission (admin always, staff with kyc.attempts.reset) and only when a try was used today.
export const showReset = (info, canReset) => !!canReset && !!info && info.used > 0;

// Reset all: offered when at least one document has used tries.
export const showResetAll = (today, canReset) => !!canReset && Object.values(today || {}).some((info) => info && info.used > 0);

export const resetBody = (documentType) => (documentType ? { documentType } : {});
